declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';


import { DBOperation } from '../../../../../enums/enum';
import { ActorProfessionalReferenceRequest, ActorProfessionalReferencesInfoController } from '../../../../../models/profileinfo/profileinfo.model';

import { HCPService } from '../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';

@Component({
  selector: 'ngbprofessionalreference',
  templateUrl: './professionalreference.modal.html',
  styleUrls: ['./professionalreference.modal.scss']
})

export class NgbProfessionalReferenceInfoModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() ActorCode: number;
  @Input() CurrentActorProfessionalReferencesInfoControllerByCode: ActorProfessionalReferencesInfoController;

  CurrentActorProfessionalReferenceRequest: ActorProfessionalReferenceRequest;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private tosterservice: NGXToastrService) { }
  ngOnInit() {

    this.CurrentActorProfessionalReferenceRequest = new ActorProfessionalReferenceRequest();
    this.CurrentActorProfessionalReferenceRequest.ActorCode = this.ActorCode;
    this.CurrentActorProfessionalReferenceRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  }



  onSubmit() {

    this.StartRefreshing();
    this.CurrentActorProfessionalReferenceRequest.ConditionalOperator = 1;
    this.hcpservice.SaveActorProfessionalReference(this.CurrentActorProfessionalReferenceRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {


          //alertFunctions.AlertParam('Saved Successfully.....!');
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

          this.activeModal.close();

          this.stopRefreshing();




        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.activeModal.close();
          this.stopRefreshing();
        }
      }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  //
  ///////////////////DetailGrid
  //Grid Vars start
  disREADONLY: boolean = false;

  ddbops: DBOperation;
  dcolumns: any[] = [
    {
      display: 'FacilityName',
      variable: 'FacilityName',
      filter: 'text',
    },
    {
      display: 'ContactPerson',
      variable: 'ContactPerson',
      filter: 'text'
    },
    {
      display: 'ContactPersonTitle',
      variable: 'ContactPersonTitle',
      filter: 'text'
    }
    ,
    {
      display: 'Address',
      variable: 'Address',
      filter: 'text'
    }
    ,
    {
      display: 'PhoneNo',
      variable: 'PhoneNo',
      filter: 'text'
    }
    


  ];




}
